import { inject, Injectable } from "@angular/core";
import { LocationOption } from "../../store/header/header.models";
import { Observable, of } from "rxjs";
import { OperatorsService } from "./operators.service";

@Injectable({
    providedIn: 'root',
})
export class GlobalFilterService {
    private operatorsService: OperatorsService = inject(OperatorsService);

    getLocationOptions(operatorId: string | null = null): Observable<LocationOption[]> {
        if (operatorId) {
            return of(fakeLocationsMap[operatorId] ?? []);
        } else {
            const allLocations = Object.values(fakeLocationsMap).flat();
            return of(allLocations);
        }
    }

}

const fakeLocationsMap: Record<string, LocationOption[]> = {
    '8abb98a2-4d99-4175-a71d-4f26047ecca8': [
        {
            id: '1',
            name: 'Location 1'
        },
        {
            id: '2',
            name: 'Location 2'
        }
    ],
    '2': [
        {
            id: '3',
            name: 'Location 3'
        }
    ]
}